import React from "react"
import styled, { css } from "styled-components"
import { rem } from "polished"
import Link from "gatsby-link"
import { motion } from "framer-motion"
import { Parallax } from "react-scroll-parallax"

import Visual from "../../visual"

const Slide = styled(Link)`
  display: block;
  // border: 1px solid red;

  @media ${props => props.theme.mobileUp} {
    flex: 1 1 0px;
    transform: rotate(-15deg);
  }

  @media ${props => props.theme.mobileDown} {
    transform: none;
    display: block;

    &:not(:first-of-type) {
      margin-top: ${rem(30)};
    }
  }
`

const ImageWrapper = styled.div`
  position: absolute;
  pointer-events: none;
  // border: 1px solid red;
`

const ProjectLayout = styled(motion.div)`
  position: relative;
  // border: 1px solid red;

  ${props =>
    props.layoutType === 1 &&
    css`
      ${ImageWrapper} {
        &:nth-of-type(1) {
          width: 26.875%;
          top: 67.25%;
          transform: rotate(-2.25deg);
          left: 69.1875%;
          z-index: 2;
        }

        &:nth-of-type(2) {
          width: 32.875%;
          transform: rotate(1.68deg);
          top: 51.25%;
          left: 4.125%;
          z-index: 2;
        }

        &:nth-of-type(3) {
          width: 64.125%;
          left: 35.875%;
          top: 5.5%;
        }

        &:nth-of-type(4) {
          width: 52.1875%;
          transform: rotate(-5.79deg);
          left: 0;
          top: 0;
          z-index: -1;
        }

        &:nth-of-type(5) {
          width: 65.75%;
          transform: rotate(1.4deg);
          left: 9.5%;
          top: 0;
          z-index: -1;
        }
      }
    `}  

  ${props =>
    props.layoutType === 2 &&
    css`
      ${ImageWrapper} {
        &:nth-of-type(1) {
          width: 19.875%;
          bottom: 0;
          transform: rotate(4.04deg);
          left: 19.875%;
          z-index: 2;
        }

        &:nth-of-type(2) {
          width: 31.125%;
          transform: rotate(-1.53deg);
          top: 2.87%;
          right: 0;
          z-index: 2;
        }

        &:nth-of-type(3) {
          width: 77.625%;
          left: 13.25%;
          top: 0;
        }

        &:nth-of-type(4) {
          width: 84.18%;
          transform: rotate(1.8deg);
          left: 0;
          top: 4.5%;
          z-index: -1;
        }
      }
    `}  

  ${props =>
    props.layoutType === 3 &&
    css`
      ${ImageWrapper} {
        &:nth-of-type(1) {
          width: 27.8125%;
          top: 45.125%;
          left: 72.1875%;
          z-index: 3;
          transform: rotate(3.75deg);
        }

        &:nth-of-type(2) {
          width: 20.4375%;
          transform: rotate(2.45deg);
          top: 67.5%;
          left: 7.25%;
          z-index: 2;
        }

        &:nth-of-type(3) {
          width: 58.3125%;
          top: 4.75%;
          left: 29.125%;
          z-index: 2;
        }

        &:nth-of-type(4) {
          width: 56.3125%;
          top: 0;
          left: 0;
          transform: rotate(-2.34deg);
        }
      }
    `}  

  ${props =>
    props.layoutType === 4 &&
    css`
      ${ImageWrapper} {
        &:nth-of-type(1) {
          width: 39.3125%;
          top: 55.125%;
          left: 9.25%;
          z-index: 2;
        }

        &:nth-of-type(2) {
          width: 25%;
          transform: rotate(-2.03deg);
          top: 9.25%;
          left: 75%;
          z-index: 2;
        }

        &:nth-of-type(3) {
          width: 61.4375%;
          left: 23.0625%;
          top: 6.25%;
        }

        &:nth-of-type(4) {
          width: 75%;
          transform: rotate(-2.4deg);
          left: 0;
          top: 0;
        }

        &:nth-of-type(5) {
          width: 43.9375%;
          transform: rotate(6.41deg);
          left: 56.0625%;
          top: 34.75%;
        }
      }
    `}  

  ${props =>
    props.layoutType === 5 &&
    css`
      ${ImageWrapper} {
        &:nth-of-type(1) {
          width: 24%;
          top: 67%;
          left: 27.0625%;
          z-index: 3;
        }

        &:nth-of-type(2) {
          width: 29.8125%;
          transform: rotate(-1.81deg);
          top: 54.25%;
          left: 70.125%;
          z-index: 3;
        }

        &:nth-of-type(3) {
          width: 54.11%;
          left: 19.56%;
          top: 6.375%;
          z-index: 2;
        }

        &:nth-of-type(4) {
          width: 42.93%;
          transform: rotate(2.47deg);
          left: 0;
          top: 0;
        }

        &:nth-of-type(5) {
          width: 36.875%;
          transform: rotate(2.48deg);
          left: 62.5%;
          top: 0;
        }
      }
    `}  

  ${props =>
    props.layoutType === 6 &&
    css`
      ${ImageWrapper} {
        &:nth-of-type(1) {
          width: 26.125%;
          left: 12.5%;
          top: 68.25%;
          z-index: 2;
        }

        &:nth-of-type(2) {
          width: 81.43%;
          transform: rotate(-1.53deg);
          left: 6.3125%;
          top: 15.5%;
        }

        &:nth-of-type(3) {
          width: 57.375%;
          transform: rotate(1.62deg);
          bottom: 0;
          right: 0;
          z-index: -1;
        }

        &:nth-of-type(4) {
          width: 47%;
          z-index: -1;
        }
      }
    `}  

  ${props =>
    props.layoutType === 7 &&
    css`
      ${ImageWrapper} {
        &:nth-of-type(1) {
          width: 39%;
          transform: rotate(3.04deg);
          left: 55%;
          top: 20%;
          z-index: 2;
        }

        &:nth-of-type(2) {
          width: 25%;
          bottom: 0;
          left: 13.75%;
          z-index: 2;
        }

        &:nth-of-type(3) {
          width: 70.25%;
          left: 8.25%;
          top: 0;
        }

        &:nth-of-type(4) {
          width: 94%;
          transform: rotate(-2deg);
          left: 2%;
          top: 3.3%;
          z-index: -1;
        }

        &:nth-of-type(5) {
          width: 67.5%;
          transform: rotate(3deg);
          right: 2%;
          bottom: 3.3%;
          z-index: -1;
        }
      }
    `}  

  ${props =>
    props.layoutType === 8 &&
    css`
      ${ImageWrapper} {
        &:nth-of-type(1) {
          z-index: 3;
          width: 28.75%;
          transform: rotate(4deg);
          left: 20.375%;
          bottom: 2.5%;
        }

        &:nth-of-type(2) {
          z-index: 3;
          right: 12.5%;
          bottom: 0;
          width: 18.5%;
        }

        &:nth-of-type(3) {
          top: 12.5%;
          left: 8.75%;
          width: 82.5%;
          z-index: 2;
        }

        &:nth-of-type(4) {
          top: 3.75%;
          left: 1.25%;
          width: 67.5%;
          z-index: 1;
          transform: rotate(-3.18deg);
        }

        &:nth-of-type(5) {
          top: 3.75%;
          right: 0;
          width: 32.125%;
          z-index: 1;
          transform: rotate(3.18deg);
        }
      }
    `}

  ${props =>
    props.layoutType === 9 &&
    css`
      ${ImageWrapper} {
        &:nth-of-type(1) {
          bottom: 0;
          left: 13%;
          width: 31%;
          transform: rotate(-2.5deg);
          z-index: 2;
        }

        &:nth-of-type(2) {
          width: 20%;
          bottom: 21%;
          right: 0%;
          transform: rotate(3deg);
          z-index: 2;
        }

        &:nth-of-type(3) {
          z-index: 1;
          left: 23.75%;
          top: 10%;
          width: 66%;
        }

        &:nth-of-type(4) {
          z-index: 0;
          width: 69%;
          transform: rotate(-4deg);
          left: 0;
          top: 5%;
        }
      }
    `}

  ${props =>
    props.layoutType === 10 &&
    css`
      ${ImageWrapper} {
        &:nth-of-type(1) {
          z-index: 2;
          width: 36.66%;
          transform: rotate(2.6deg);
          right: 2%;
          top: 6.75%;
        }

        &:nth-of-type(2) {
          bottom: 0;
          left: 20.875%;
          width: 25%;
          z-index: 2;
        }

        &:nth-of-type(3) {
          top: 7.5%;
          left: 12.5%;
          width: 62.44%;
          z-index: 1;
        }

        &:nth-of-type(4) {
          width: 81.375%;
          left: 4%;
          top: -1%;
          transform: rotate(-5deg);
        }

        &:nth-of-type(5) {
          width: 50%;
          right: 4%;
          bottom: 2%;
          transform: rotate(2deg);
        }
      }
    `}

  &::after {
    content: "";
    display: block;
    padding-top: 50%;
  }
`

const SingleSlide = props => {
  return (
    <Slide to={`/work/${props.slug}`} aria-label="See case study">
      <ProjectLayout layoutType={parseInt(props.layoutType)}>
        {props.photos.map((item, index) => (
          <ImageWrapper key={index}>
            {index % 2 === 0 ? (
              <Parallax y={[20, -20]}>
                <Visual {...item} />
              </Parallax>
            ) : (
              <Visual {...item} />
            )}
          </ImageWrapper>
        ))}
      </ProjectLayout>
    </Slide>
  )
}

export default SingleSlide
